import 'stylesheets/friend_referrals_deferred.css';
import 'common';

import {onFirstScroll} from 'components/on_first_scroll';
import {referAFriendAttribution} from 'referrals/refer_a_friend_attribution';
import {signUpFormEnhancements} from 'referrals/sign_up_form_enhancements';

referAFriendAttribution();
signUpFormEnhancements();

onFirstScroll('friendReferrals', () => {
  import(/* webpackChunkName: "AccordionComponent" */ 'components/accordion').then(module =>
    new module.AccordionComponent().mount(),
  );
});
